import {
    CommanderFormProps,
    SchemaFormFields,
    useDialogForm,
    useHandledDialogFormControls,
} from '@mews-commander/form';
import { createZodFormResolver, getBase64, getDefaults, lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { useCurrentService } from '../queries/useCurrentService';
import { ProductCategoryFormValues, useProductCategoryFormSchema } from './schemas/productCategoryFormSchema';
import { useProductCategoryFormDefinition } from './formDefinitions/productCategoryFormDefinition';

const CreateProductCategoryFormContent = (props: CommanderFormProps) => {
    const productCategoryFormSchema = useProductCategoryFormSchema();
    const { mutateAsync } = useRepositoryMutation('productCategories', 'add', {
        invalidateQueries: { products: ['getOverviewEntries'], productCategories: ['getAll'] },
        onSuccess: () => {
            showSuccessAlert({ description: lt('ProductCategoryCreatedSuccessMessage') });
        },
    });

    const productCategoryFormDefinition = useProductCategoryFormDefinition();
    const { id } = useCurrentService();

    const { renderFormContent } = useHandledDialogFormControls<ProductCategoryFormValues>({
        ...props,
        defaultValues: getDefaults(productCategoryFormSchema),
        onSubmit: async ({ image, ...values }) =>
            mutateAsync({
                serviceId: id,
                ...values,
                image:
                    image && image[0]
                        ? {
                              name: image[0].name,
                              type: image[0].type,
                              data: await getBase64(image[0]),
                          }
                        : null,
            }),
        resolver: createZodFormResolver(productCategoryFormSchema),
    });

    return renderFormContent(
        <SchemaFormFields schema={productCategoryFormSchema} formDefinition={productCategoryFormDefinition} />
    );
};

export const useProductCategoryDialogForm = () =>
    useDialogForm({
        id: 'create-product-category-form',
        title: lt('ProductCategoryFormTitleCreateProductCategory'),
        saveLabel: lt('Create'),
        renderForm: (props) => <CreateProductCategoryFormContent {...props} />,
    });
